import React, { useEffect, useState } from "react";
import { PiSignOutBold } from "react-icons/pi";
import useAuthStore from "../../../store/authStore";
import { Button, message, Modal, Spin } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import ChangePasswordModal from "./ChangePasswordModal";
import {
  updateManagerGeneral,
  updateManagerNotification,
} from "../../../api/ManagerRequestApi";

const { confirm } = Modal;
const ManagerSettings = () => {
  const { refToken, logout, user, updateUser } = useAuthStore();
  const tabs = [
    "Account Settings",
    "Notification & Preferences",
    // "Admin Permissions",
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const [accountSettingLoader, setaccountSettingLoader] = useState(false);
  const [notificationLoader, setNotificationLoader] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [editedProfile, setEditedProfile] = useState(user);

  // ------------LOGOUT FUNCTION-----------
  const handleLogout = () => {
    confirm({
      title: "Are you sure you want to log out?",
      icon: <ExclamationCircleOutlined />,
      content: "You will be redirected to the login page.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        logout(refToken);
      },
      onCancel() {
        console.log("Logout cancelled");
      },
    });
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = async () => {
    setaccountSettingLoader(true);
    try {
      const { data } = await updateManagerGeneral(editedProfile);

      if (data.success) {
        updateUser(data.user)

        message.success("Profile updated successfully");
        setIsEditing(false);
      }
      else {
        message.error("Failed to update profile");
      }
    } catch (error) {
      console.error("Error updating preferences:", error);
      message.error("Failed to update notification preferences");
    } finally {
      setaccountSettingLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedProfile((prev) => ({ ...prev, [name]: value }));
  };

  const [isChangePasswordModalVisible, setIsChangePasswordModalVisible] =
    useState(false);

  const showChangePasswordModal = () => {
    setIsChangePasswordModalVisible(true);
  };

  const handleChangePasswordSuccess = () => {
    setIsChangePasswordModalVisible(false);
  };

  const [preferences, setPreferences] = useState({
    newSurveyRequest: false,
    assignedSurveysNotAccepted: false,
    surveysNotCompleted: false,
    newVerificationRequest: false,
  });
  const [initialPreferences, setInitialPreferences] = useState({});
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setInitialPreferences(
      user.notificationPreferences || {
        newSurveyRequest: false,
        assignedSurveysNotAccepted: false,
        surveysNotCompleted: false,
        newVerificationRequest: false,
      }
    );
    setPreferences(
      user.notificationPreferences || {
        newSurveyRequest: false,
        assignedSurveysNotAccepted: false,
        surveysNotCompleted: false,
        newVerificationRequest: false,
      }
    );
  }, [user.notificationPreferences]);

  useEffect(() => {
    if (!preferences || !initialPreferences) {
      console.error("preferences or initialPreferences is undefined");
      return; // Exit early if undefined
    }
    const changed = Object.keys(preferences).some(
      (key) => preferences[key] !== initialPreferences[key]
    );
    setHasChanges(changed);
  }, [preferences, initialPreferences]);

  const handlePreferenceChange = (event) => {
    const { name, checked } = event.target;
    setPreferences((prev) => ({ ...prev, [name]: checked }));
  };

  const savePreferences = async () => {
    setNotificationLoader(true);
    try {
      const { data } = await updateManagerNotification({
        preferences: preferences,
      });
      if (data.success) {
        updateUser(data.updatedUser);
        message.success("Notification preferences updated successfully");
        setHasChanges(false); // Reset changes flag
      } else {
        throw new Error("Failed to update preferences");
      }
    } catch (error) {
      console.error("Error updating preferences:", error);
      message.error("Failed to update notification preferences");
    } finally {
      setNotificationLoader(false);
    }
  };

  const notificationOptions = [
    { name: "newSurveyRequest", label: "A new survey request is received" },
    { name: "newBidSubmission", label: "A new bid request is received" },
    { name: "bidReSubmission", label: "A  bid resubmit request is received" },
    { name: "newSurveyAssigned", label: "surveys Assigned by Admin" },
    { name: "bidApproved", label: "Bid approved by Admin" },
    { name: "bidRejected", label: "New rejected by Admin" },
    { name: "assignedSurveysAccepted", label: "Assigned surveys are accepted" },
    { name: "assignedSurveysRejected", label: "Assigned surveys are not accepted" },
    { name: "assignedSurveysOngoing", label: "Assigned surveys are ongoing" },
    { name: "assignedSurveysCompleted", label: "Assigned surveys are complted" },
    { name: "surveysNotCompleted", label: "Surveys are not completed within the completion period" },
    { name: "newVerificationRequest", label: "New verification request is received" },
  ];

  return (
    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <div className="">
        <div className="lg:sticky top-0 pb-3 lg:z-10 bg-white">
          <div className="flex flex-wrap justify-between items-center mb-4 gap-2 mt-2">
            <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white mb-3">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                  ${activeTab === tab
                      ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                      : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                    }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="w-full lg:w-auto">
              <button
                className="px-4 py-2 bg-[#FF4545] flex hover:text-[#FF4545] hover:border-[#FF4545] hover:bg-white border items-center justify-center gap-2 text-white rounded-[8px] underline text-[16px] font-semibold w-full lg:w-auto"
                onClick={handleLogout}
              >
                <PiSignOutBold /> Sign out
              </button>
            </div>
          </div>
        </div>
        <div className="">
          {activeTab === "Account Settings" && (
            <div>
              <div className="border-b-[#A3BBFF] pb-10 border-b-[1px]">
                <div className="flex items-center gap-2 mb-6">
                  <h2 className="text-[20px] text-[#000000] font-semibold text-start ">
                    General Details
                  </h2>
                  {!isEditing && (
                    <button
                      className="text-[#1955EB] text-[14px] underline font-semibold "
                      onClick={handleEdit}
                    >
                      Change
                    </button>
                  )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label className="text-[#313131] text-[16px] font-semibold text-start mb-2">
                      Full Name
                    </label>
                    {isEditing ? (
                      <input
                        type="text"
                        name="name"
                        value={editedProfile?.name || ""}
                        onChange={handleChange}
                        className={`px-3 py-2 border ${"border-[#1955EB]"} text-[#4A4A4C] font-medium text-[14px] rounded-lg`}
                      />
                    ) : (
                      <div className="flex items-center justify-between md:justify-start gap-4 md:gap-10">
                        <span className="text-[#878787] text-[14px] font-semibold">
                          {user?.name}
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col">
                    <label className="text-[#313131] text-[16px] font-semibold text-start mb-2">
                      Phone Number
                    </label>
                    {isEditing ? (
                      <input
                        type="text"
                        name="phone"
                        value={editedProfile?.phone || ""}
                        onChange={handleChange}
                        className={`px-3 py-2 border ${"border-[#1955EB]"} text-[#4A4A4C] font-medium text-[14px] rounded-lg `}
                      />
                    ) : (
                      <div className="flex items-center justify-between md:justify-start gap-4 md:gap-10">
                        <span className="text-[#878787] text-[14px] font-semibold">
                          {user?.phone}
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col md:col-span-2">
                    <label className="text-[#313131] text-[16px] font-semibold text-start mb-2">
                      Email Address
                    </label>
                    <div className="flex items-center justify-between md:justify-start gap-4 md:gap-10">
                      <span className="text-[#878787] text-[14px] font-semibold">
                        {user?.email}
                      </span>
                    </div>
                  </div>
                </div>
                {isEditing && (
                  <div className="flex mt-4 space-x-4">
                    <Button onClick={handleCancel}>Cancel</Button>
                    <Button type="primary" onClick={handleSave} loading={accountSettingLoader}>
                      Save
                    </Button>
                  </div>
                )}
              </div>
              <div className="pt-3">
                <h2 className="text-start text-[20px] text-[#000000] font-semibold mb-3">
                  Privacy & Security
                </h2>
                <div className="flex justify-start">
                  <button
                    className="text-[#1955EB] text-[14px] underline font-semibold"
                    onClick={showChangePasswordModal}
                  >
                    Change Password
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === "Notification & Preferences" && (
            // <div className="">
            //   <h2 className="text-[20px] text-[#000000] text-start font-semibold mb-3">
            //     Customize Notifications
            //   </h2>
            //   <p className="text-[#313131] text-[16px] text-start font-semibold mb-4">
            //     Choose the notifications you wish to receive when:
            //   </p>
            //   <div className="space-y-4">
            //     <label className="flex items-center space-x-2">
            //       <input
            //         type="checkbox"
            //         name="newSurveyRequest"
            //         checked={preferences.newSurveyRequest}
            //         onChange={handlePreferenceChange}
            //         className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
            //       />
            //       <span className="text-[#313131] text-[16px]">
            //         A new survey request is received
            //       </span>
            //     </label>
            //     <label className="flex items-center space-x-2">
            //       <input
            //         type="checkbox"
            //         name="assignedSurveysNotAccepted"
            //         checked={preferences.assignedSurveysNotAccepted}
            //         onChange={handlePreferenceChange}
            //         className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
            //       />
            //       <span className="text-[#313131] text-[16px]">
            //         Assigned surveys are not accepted
            //       </span>
            //     </label>
            //     <label className="flex items-center space-x-2">
            //       <input
            //         type="checkbox"
            //         name="surveysNotCompleted"
            //         checked={preferences.surveysNotCompleted}
            //         onChange={handlePreferenceChange}
            //         className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
            //       />
            //       <span className="text-[#313131] text-[16px]">
            //         Surveys are not completed within the completion period
            //       </span>
            //     </label>
            //     <label className="flex items-center space-x-2">
            //       <input
            //         type="checkbox"
            //         name="newVerificationRequest"
            //         checked={preferences.newVerificationRequest}
            //         onChange={handlePreferenceChange}
            //         className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
            //       />
            //       <span className="text-[#313131] text-[16px]">
            //         New verification request is received
            //       </span>
            //     </label>
            //   </div>
            //   <div className="mt-6">
            //     <Button
            //       loading={notificationLoader}
            //       onClick={savePreferences}
            //       disabled={!hasChanges}
            //       type="primary"
            //     >
            //       Save Preferences
            //     </Button>
            //   </div>
            // </div>
            <div className="">
              <h2 className="text-[20px] text-[#000000] text-start font-semibold mb-3">
                Customize Notifications
              </h2>
              <p className="text-[#313131] text-[16px] text-start font-semibold mb-4">
                Choose the notifications you wish to receive when:
              </p>
              <div className="space-y-4">
                {notificationOptions.map((option) => (
                  <label key={option.name} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      name={option.name}
                      checked={preferences?.[option.name] || false}
                      onChange={handlePreferenceChange}
                      className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
                    />
                    <span className="text-[#313131] text-[16px]">{option.label}</span>
                  </label>
                ))}
              </div>
              <div className="mt-6">
                <Button
                  loading={notificationLoader}
                  onClick={savePreferences}
                  disabled={!hasChanges}
                  className={`px-4 py-2 bg-[#1955EB] text-white border rounded-lg text-[16px] font-semibold
              ${hasChanges
                      ? "hover:text-[#1955EB] hover:bg-white hover:border-[#1955EB]"
                      : "opacity-50"
                    }`}
                >
                  Save Preferences
                </Button>
              </div>
            </div>
          )}
        </div>
        <ChangePasswordModal
          visible={isChangePasswordModalVisible}
          onCancel={() => setIsChangePasswordModalVisible(false)}
          onSuccess={handleChangePasswordSuccess}
        />
      </div>
    </div>
  );
};

export default ManagerSettings;
